"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cancellationPolicy = require("../../HotelCard/components/utils/cancellationPolicy");
var _tagTypes = require("./tagTypes");
var getTags = function getTags(extras, isHotelOnly, cancellationPolicy) {
  var hotelTags = [];
  // Для отелей не показываем плашку "мгновенного подтверждения"
  if (extras.instant_confirm && !isHotelOnly) {
    hotelTags.push({
      type: 'instantConfirm'
    });
  }
  // Для отелей показываем плашку "долгого подтверждения"
  if (!extras.instant_confirm && isHotelOnly) {
    hotelTags.push({
      type: 'notToConfirmAtOnce'
    });
  }
  if ((0, _cancellationPolicy.isFreeCancellation)(cancellationPolicy)) {
    hotelTags.push({
      type: 'freeCancellation',
      tooltipText: ''
    });
  }
  var sorted = hotelTags.sort(function (first, second) {
    return _tagTypes.TYPES[first.type].order - _tagTypes.TYPES[second.type].order;
  });
  return sorted.slice(0, 2);
};
var _default = exports["default"] = getTags;